angular.module('elfium').factory('elfiumListFilterFactory', ['$filter', function ($filter) {
    return function ($scope, objectsList, filters, filteredObjectsNameOnScope, dateFilters, daterangeFilter) {
        daterangeFilter = daterangeFilter || 'elfiumDaterange';
        var that = this;
        that._originalFilters = angular.copy(filters);
        that._originalDateFilters = angular.copy(dateFilters);
        that._cleanFilters = function () {
            angular.forEach(filters, function (filterValue, key) {
                if (!filterValue) {
                    delete filters[key];
                }
            });
        };
        that._filterObjectList = function () {
            var filteredResult = $filter('elfiumFilter')(objectsList, filters);
            $scope[filteredObjectsNameOnScope] = $filter(daterangeFilter)(filteredResult, dateFilters);
        };
        that.filter = function () {
            that._cleanFilters();
            that._filterObjectList();
        };
        that.reset = function () {
            angular.forEach(filters, function (filterValue, key) {
                delete filters[key];
            });
            angular.forEach(dateFilters, function (filterValue, key) {
                delete dateFilters[key];
            });
            angular.extend(filters, angular.copy(that._originalFilters));
            angular.extend(dateFilters, angular.copy(that._originalDateFilters));
        };
        $scope.$watch(function () {
            return filters;
        }, that.filter, true);
        $scope.$watch(function () {
            return dateFilters;
        }, that.filter, true);
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumListFilterFactory.ts